import React, { useState, useEffect } from 'react';
import { COURSE_COUNT } from 'constants/site-stats.const';

import { useRouter } from 'next/router';

import { useForm } from 'react-hook-form';
// Request Dependency
import { useMutation } from 'react-query';
import { registerService } from 'services/auth';
import { setAuthorization, affiliateMarketingCodeUtils } from 'utils/authentication';

import useDeviceIdentify from 'hooks/use-deviceidentify';
import UseActivities from 'hooks/use-activities';
// Toasting error Response
import UseToast from 'hooks/use-toast';
// Custom Components
import TextInput from '@core/components/textinput/TextInput';
import PasswordInput from '@core/components/passwordinput/PasswordInput';
import ActionButton from '@core/components/actionbutton/ActionButton';
import BackButton from '@core/components/backbutton/BackButton';
import RegisterCarousel from '@core/components/registercarousel/RegisterCarousel';

import { NextSeo } from 'next-seo';
import { generateSeoProps } from 'router/seoprops/generateSeoProps';
import { checkUserInfoFlow } from 'utils/routerUtils';

import classes from './Register.module.scss';


const Register = () => {
	const { handleDeviceIdentification } = useDeviceIdentify();
	const { sendUTM } = UseActivities();
	const [originUrl, setOriginUrl] = useState('');
	const router = useRouter();
	const { toast, ToastContainer } = UseToast();
	const { mutate: callRegisterApi, isLoading } = useMutation(registerService, {
		onSuccess: (data, variables) => {
			affiliateMarketingCodeUtils.delete();
			setAuthorization(data.data);
			sendUTM();
			handleDeviceIdentification();
			const isRedirected = checkUserInfoFlow({ data: data.data, router });
			if (!isRedirected)
				router.push('/register-verify', {
					query: { userEmail: variables.email },
					pathname: '/register-verify'
				});
		},
		onError: (error) => {
			toast(error?.response?.data?.data || 'Something went wrong! please try again', 'Alert');
		}
	});

	const seoProps = generateSeoProps({
		title: 'Sign-Up: Start Pharma Career Training - Pharmuni',
		description: `Sign up in seconds to explore ${COURSE_COUNT} GMP, QA and regulatory courses, build your resume and accelerate your pharmaceutical career.`,
		canonical: 'register'
	});

	// setup UseForm
	const {
		register,
		handleSubmit,
		formState: { errors }
	} = useForm({ mode: 'onChange', delayError: 1000 });

	const onSubmit = (value) => {
		const affiliate_marketing_code = affiliateMarketingCodeUtils.get();
		// registerService();
		callRegisterApi({ ...value, affiliate_marketing_code: affiliate_marketing_code || null });
	};
	useEffect(() => {
		if (typeof window !== 'undefined') {
			setOriginUrl(window.location.origin);
		}
	}, []);

	return (
		<>
			<NextSeo {...seoProps} />
			<ToastContainer />

			<div className="container">
				<div className={`${classes['wrapper']} `}>
					<div className="row">
						<div className='col-12 col-xl-6 p-0 d-flex align-items-center justify-content-center'>
							<div className={`${classes['register-wrapper']} d-flex flex-column align-items-center `}>
								<div className={`${classes['register']}  d-flex flex-column align-items-stretch`}>
									<BackButton type="text" className="d-none d-md-flex mb-4" />
									<h1>Register</h1>
									<form onSubmit={handleSubmit(onSubmit)}>
										<TextInput
											validation={{
												required: true,
												pattern: {
													value:
														/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
													message: 'Please enter a correct email address'
												}
											}}
											input={{
												type: 'email',
												label: 'Email Address',
												name: 'email',
												placeholder: 'Email',
												id: 'email',
												autoComplete: 'off'
											}}
											errors={errors}
											register={register}
										/>
										<PasswordInput errors={errors} register={register} />
										<p>
											By creating an account, you agree to our{' '}
											<a href={`${originUrl}/terms-and-conditions/`} rel="noreferrer">
												terms and conditions
											</a>{' '}
											and{' '}
											<a href={`${originUrl}/privacy-policy/`} rel="noreferrer">
												privacy policy
											</a>
											.
										</p>
										<ActionButton type="submit" disabled={isLoading} loading={isLoading}>
											Create account{' '}
										</ActionButton>
									</form>
								</div>
							</div>
						</div>
						<div className='d-none d-xl-block col-xl-6 '>
							<RegisterCarousel />
						</div>
					</div>
				</div>
			</div>

		</>
	);
};

export default Register;
